import React, { useState, useEffect } from 'react';

const DocsTableOfContents = () => {
  const [headings, setHeadings] = useState([]);
  const [activeId, setActiveId] = useState('');

  useEffect(() => {
    // Extract headings from the page
    const extractHeadings = () => {
      const article = document.querySelector('article');
      if (!article) return [];

      const headingElements = article.querySelectorAll('h2, h3');
      return Array.from(headingElements).map(heading => ({
        id: heading.id,
        text: heading.textContent,
        level: parseInt(heading.tagName.charAt(1)),
      }));
    };

    // Update headings when content changes
    const updateHeadings = () => {
      const newHeadings = extractHeadings();
      setHeadings(newHeadings);
    };

    // Initial extraction
    updateHeadings();

    // Use MutationObserver to detect content changes
    const observer = new MutationObserver(updateHeadings);
    const article = document.querySelector('article');
    
    if (article) {
      observer.observe(article, {
        childList: true,
        subtree: true,
      });
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    // Track active heading based on scroll position
    const handleScroll = () => {
      const headingElements = headings.map(h => document.getElementById(h.id)).filter(Boolean);
      
      // Find the heading that's currently in view
      for (let i = headingElements.length - 1; i >= 0; i--) {
        const heading = headingElements[i];
        const rect = heading.getBoundingClientRect();
        
        if (rect.top <= 100) {
          setActiveId(heading.id);
          return;
        }
      }
      
      // If no heading is in view, clear active
      if (headingElements.length > 0) {
        setActiveId(headingElements[0].id);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, [headings]);

  const scrollToHeading = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80; // Account for fixed header
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  if (headings.length === 0) return null;

  return (
    <div className="py-4">
      <h4 className="text-sm font-semibold mb-4 text-foreground/80">On This Page</h4>
      <nav className="space-y-2">
        {headings.map(heading => (
          <button
            key={heading.id}
            onClick={() => scrollToHeading(heading.id)}
            className={`block text-left text-sm transition-colors ${
              heading.level === 3 ? 'pl-4' : ''
            } ${
              activeId === heading.id
                ? 'text-purple-400 font-medium'
                : 'text-foreground/60 hover:text-foreground'
            }`}
          >
            {heading.text}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default DocsTableOfContents;

